import { render, staticRenderFns } from "./CoreSelectOrganizations.vue?vue&type=template&id=6cb0a32d"
import script from "./CoreSelectOrganizations.vue?vue&type=script&lang=js"
export * from "./CoreSelectOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports